export default __webpack_public_path__ + "static/media/logoTickets.0c8a6b30.png";